/**
 * @author vishwadeep.kapoor
 * @description contains all the URL's to be used in all the instances
 * @property
 *    @arg SET_ for all API having update and create request
 *    @arg GET_ for all API having fetching request
 */

import AWS_STATIC_FILES from './imagesEndPoints';

/**
 * @default EndPoints @constant {GROUP_DINING_BASEURL,GOOGLE_MAP}
 */
const GROUP_DINING_BASEURL = 'https://group-dining-api.zaggle.in/api';
const GOOGLE_MAP = 'https://maps.googleapis.com/maps/api/geocode/json';

const API_NODE_SERVER = {
  USER_PROFILE: '/profile', /** @desc updated API {/profile/info} */
  POST_AUTH_LOGGER: '/authLogger',
  POST_SET_TOKEN: '/setToken',
  GET_TOKEN: '/getToken',
};

const PressLinks = {
  PRESS_COVID19:
    'https://www.newindianexpress.com/lifestyle/health/2020/may/08/i-want-to-see-a-better-me-post-covid-19-zaggle-founder-raj-n-phani-2140658.html',
  PRESS_BT_BUZZ:
    'https://www.businesstoday.in/bt-buzz/news/bt-buzz-mukesh-ambani-mark-zuckerberg-and-the-700-billion-kirana-puzzle/story/401746.html',
  PRESS_HINDU_ZAGG_VISA_TIE:
    'https://www.thehindu.com/business/zaggle-visa-tie-up-for-sme-payments/article31660334.ece',
  PRESS_YOUSTORY_ZAGG_VISA_COVID19:
    'https://yourstory.com/2020/05/zaggle-partners-visa-launch-payment-solution-sme-startup-coronavirus',
  PRESS_OUTLOOKINDIA_ZAGG_VISA_TIE:
    'https://www.outlookindia.com/newsscroll/fintech-startup-zaggle-ties-up-with-visa-for-innovative-paymentssolutions-for-smes/1843846',
  PRESS_ECONOMICTIMES:
    'https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/fintech-startup-zaggle-joins-hands-with-visa-to-launch-payment-solutions-for-smes-startups/articleshow/75917620.cms',
  PRESS_BUSINESS_STANDARD:
    'https://www.business-standard.com/article/pti-stories/fintech-startup-zaggle-ties-up-with-visa-for-innovative-paymentssolutions-for-smes-120052300687_1.html',
  PRESS_FINANCIALEXPRESS:
    'https://www.financialexpress.com/money/covid-imapct-reimbursements-as-a-category-will-undergo-a-change/1969492/',
  PRESS_THEHINDUBUSINESSLINE:
    ' https://www.thehindubusinessline.com/companies/infosys-tcs-techm-bag-hysea-awards/article28793390.ece',
  PRESS_BRAND_AMBASSADOR:
    'https://www.thehindubusinessline.com/companies/zaggle-announces-hardik-pandya-as-brand-ambassador/article22762052.ece',
  PRESS_CASHBACK_ECONOMICTIMES:
    'https://economictimes.indiatimes.com/small-biz/startups/cashback-company-zaggle-buys-pennyful/articleshow/58101909.cms',
};

/**
 * @extends COMMON_ENDPOINTS
 * @property All GIFTCARD related API
 */
const API_GIFT_CARD = (PROXY_BASEURL) => ({
  GET_GIFTCARD_LIST: `${PROXY_BASEURL}/products/search`,
  GET_GIFTCARD_PAGE_FILTERS_LIST: `${PROXY_BASEURL}/products/search/filters`,
  GET_GIFTCARD_DETAILS: `${PROXY_BASEURL}/products`,
  GET_GIFTCARD_LANDING: `${PROXY_BASEURL}/products/gift_card_brands`,
  // GET_GIFTCARD_LANDING: `${GROUP_DINING_BASEURL}/webservices/gift_card_brands`,
  GET_GIFT_EVOUCHERS: `${PROXY_BASEURL}/orders/evouchers`,
  GET_ACTIVATE_GIFT_EVOUCHERS: `${PROXY_BASEURL}/orders/evouchers/:token/generate_otp`, /** @desc using replace @func replace */
  GET_GIFT_EVOUCHERS_OTP: `${PROXY_BASEURL}/orders/evouchers/:token`, /** @desc using replace @func replace */
});

const API_RESTAURANTS = (MOBILE_API_BASEURL) => ({
  GET_SEARCH_MERCHANT: `${GROUP_DINING_BASEURL}/services/get_search_merchants`,
  POST_RESTURANT_DATA: `${GROUP_DINING_BASEURL}/services/get_restaurant_data`,
  POST_RESTURANT_DEAL: `${MOBILE_API_BASEURL}/webservices/addbooking`, /** @desc booking with login */
  POST_RESTURANT_BOOKING: `${GROUP_DINING_BASEURL}/webservices/add_booking_partner`, /** @desc booking without login */
  GET_RESTURANT_CUISINES: `${MOBILE_API_BASEURL}/services/cuisines`,
  GET_MERCHANT_FILTERS: `${GROUP_DINING_BASEURL}/webservices/merchant_filters`,
  GET_MERCHANT_CATEGORIES: `${GROUP_DINING_BASEURL}/webservices/merchant_categories`,
  GET_USER_BOOKINGS: `${MOBILE_API_BASEURL}/webservices/userbookings`,
  GET_MERCHANT_LOCATIONS: `${MOBILE_API_BASEURL}/webservices/locations`,
  POST_CANCEL_BOOKING: `${GROUP_DINING_BASEURL}/webservices/cancelbooking`,
});

const API_IMAGES = (MOBILE_IMAGES_BASEURL) => ({
  MERCHANT_IMAGE: `${MOBILE_IMAGES_BASEURL}/merchants`,
  MENU_IMAGE: `${MOBILE_IMAGES_BASEURL}/menus`,
  RESTAURANTS_IMAGE: `${MOBILE_IMAGES_BASEURL}/restaurants`,
});

const API_NARADA = (PROXY_BASEURL) => ({
  VERIFY_OTP: `${PROXY_BASEURL}/narada/verify_otp`,
  // ADD_CARD_YSC: `${PROXY_BASEURL}/narada/add_card`,
  ADD_CARD: `${PROXY_BASEURL}/add_card`,
  REMOVE_CARD_YSC: `${PROXY_BASEURL}/narada/remove_card`,
  GET_YSC_CARD_DETAIL: `${PROXY_BASEURL}/narada/v2_card_details`,
  GET_YSC_CARD_TRANSACTIONS: `${PROXY_BASEURL}/narada/last_transactions`,
  BLOCK_YSC_CARD: `${PROXY_BASEURL}/narada/lock_card`,
  POST_CARD_STATEMENT: `${PROXY_BASEURL}/narada/card_statement_report`,
  POST_CHANGE_INTERNET_PIN: `${PROXY_BASEURL}/narada/change_password`,
  POST_GENERATE_OTP: `${PROXY_BASEURL}/narada/generate_otp`,
  POST_RESET_PIN: `${PROXY_BASEURL}/narada/reset_pin`,
  POST_REQUEST_IPIN: `${PROXY_BASEURL}/narada/request_ipin`,
  POST_NARADA_FETCH_LIMITS: `${PROXY_BASEURL}/narada/fetch_limits`,
  POST_NARADA_UPDATE_LIMITS: `${PROXY_BASEURL}/narada/update_limits`,
  POST_GENERATE_YSC_OTP: `${PROXY_BASEURL}/narada/dedupe_otp`,
  POST_NARADA_SET_IPIN: `${PROXY_BASEURL}/narada/set_ipin`,
  POST_NARADA_RESET_PASSWORD: `${PROXY_BASEURL}/narada/reset_password`,
  POST_NARADA_BLOCK_CARD: `${PROXY_BASEURL}/narada/permanent_block_card`,
  POST_UNLOCK_YSC_CARD: `${PROXY_BASEURL}/narada/unlock_card`,
  GET_NARADA_USER_DETAILS: `${PROXY_BASEURL}/narada/user_details`,
  POST_NARADA_V2_CARD_DETAILS: `${PROXY_BASEURL}/narada/v2_card_details`,
  POST_NARADA_DEDUPE_VERIFY: `${PROXY_BASEURL}/narada/dedupe_verify`,
  POST_NARADA_LOCK_UNLOCK_WALLET: `${PROXY_BASEURL}/narada/lock_unlock_wallet`,
  GET_INDUSIND_ZINGER_CARDS_FAQ: `${PROXY_BASEURL}/narada/indusind_zinger_cards_faq`,
  GET_INDUSIND_KUBER_CARDS_FAQ: `${PROXY_BASEURL}/narada/indusind_kuber_cards_faq`,
});

const BROWSER_API = (PROXY_BASEURL) => ({
  POST_BROWSER_LOGIN: `${PROXY_BASEURL}/auth/basic`,
  DELETE_BROWSER_LOGOUT: `${PROXY_BASEURL}/auth`,
  POST_BROWSER_PASSWORD: `${PROXY_BASEURL}/profile/password/forgot`,
  POST_SIGNUP_OTP: `${PROXY_BASEURL}/auth/otp/verify`,
  POST_PASSWORD_REESET: `${PROXY_BASEURL}/profile/password/reset`,
  POST_SET_PASSWORD: `${PROXY_BASEURL}/profile/password/generate_reset_token`,
  POST_REGISTRATION: `${PROXY_BASEURL}/auth/basic/registration`,
  POST_PAY_U_PAYMENT: `${PROXY_BASEURL}/payments/payu`,
  POST_MOBIWIK_PAYMENT: `${PROXY_BASEURL}/payments/mobikwik`,
  PUT_PLACE_ORDER: `${PROXY_BASEURL}/orders/:order_id/complete`,
});

const API_YES_BANK = (PROXY_BASEURL) => ({
  POST_WALLET_REGISTER: `${PROXY_BASEURL}/wallet/ybl/register`,
  POST_WALLET_VERIFY_OTP: `${PROXY_BASEURL}/wallet/ybl/verify_mobile_otp`,
  POST_AADHAAR_KYC: `${PROXY_BASEURL}/wallet/ybl/aadhaar_kyc`,
  POST_AADHAAR_OTP_VERIFY: `${PROXY_BASEURL}/wallet/ybl/verify_aadhaar_otp`,
  POST_PHYSICAL_CARD_ACTIVATE: `${PROXY_BASEURL}/wallet/ybl/physical_card_activate`,
  GET_PHYSICAL_CARD_ACTIVATE: `${PROXY_BASEURL}/wallet/ybl/physical_card_auto_activate`,
  GET_COMPLAINT_TYPES: `${PROXY_BASEURL}/wallet/ybl/complaint_types`,
  COMPLAINT: `${PROXY_BASEURL}/wallet/ybl/complaints`,
  POST_YES_BANK_CARD_STATEMENT: `${PROXY_BASEURL}/wallet/ybl/card_statement_report`,
  GET_YES_BANK_WEARABLES_FAQS: `${PROXY_BASEURL}/wallet/ybl/wearable_faq`,
  GET_KYC_STATIC_DATA: `${PROXY_BASEURL}/wallet/ybl/kyc_static_data`,
  POST_YESBANK_MIN_KYC_UPDATE: `${PROXY_BASEURL}/wallet/ybl/update_profile_information`,
  GET_YES_BANK_ZINGER_CARD_FAQ: `${PROXY_BASEURL}/wallet/ybl/yes_bank_zinger_cards_faq`,
});

const API_YES_BANK_V3 = (PROXY_BASEURL_V3) => ({
  GET_TRANSACTION_HISTORY_V3: `${PROXY_BASEURL_V3}/wallet/ybl/fetch_transaction_history`,
  GET_WALLET_BALANCE_V3: `${PROXY_BASEURL_V3}/wallet/ybl/fetch_wallet_balance`,
  POST_UPDATE_BENEFICIARY_V3: `${PROXY_BASEURL_V3}/wallet/ybl/fetch_beneficiary`,
  GET_BENEFICIARIES_V3: `${PROXY_BASEURL_V3}/wallet/ybl/fetch_beneficiary`,

  POST_IMPS_TRANSFER_V3: `${PROXY_BASEURL_V3}/wallet/ybl/fund_transfer`,
  POST_BENEFICIARIES_V3: `${PROXY_BASEURL_V3}/wallet/ybl/add_beneficiary`,
  POST_YESBANK_DELETE_BENEFICIARY_V3: `${PROXY_BASEURL_V3}/wallet/ybl/delete_beneficiary`,
  POST_PHYSICAL_CARD_ACTIONS_V3: `${PROXY_BASEURL_V3}/wallet/ybl/manage_physical_card`,
  POST_UPDATE_BENEFICIARIES_V3: `${PROXY_BASEURL_V3}/wallet/ybl/modify_bene_limits`,
  POST_YES_BANK_OTP_V3: `${PROXY_BASEURL_V3}/wallet/ybl/send_otp`,
  POST_WALLET_TO_IMPS_V3: `${PROXY_BASEURL_V3}/wallet/ybl/wallet_to_imps`,
  POST_CHANNEL_FLAG_V3: `${PROXY_BASEURL_V3}/wallet/ybl/enable_channel`,

  GET_FETCH_ONLINE_TRANSACTION_LIMIT_V3: `${PROXY_BASEURL_V3}/wallet/ybl/fetch_txn_limits`,
  POST_UPDATE_ONLINE_TRANSACTION_LIMIT_V3: `${PROXY_BASEURL_V3}/wallet/ybl/initiate_txn_limit_update`,
  POST_YBL_MODIFY_LIMITS_OTP_V3: `${PROXY_BASEURL_V3}/wallet/ybl/verify_txn_limit_otp`,
  POST_YBL_VERIFY_LIMIT_OTP_V3: `${PROXY_BASEURL_V3}/wallet/ybl/verify_bene_limit_otp`,
});

const API_NSDL_M2P_CARD = (PROXY_BASEURL) => ({
  GET_WALLET_M2P_BALANCE: `${PROXY_BASEURL}/wallet/m2p/check_wallet_balance`,
  GET_OTP_FOR_POS_PIN_NSDL: `${PROXY_BASEURL}/wallet/m2p/generate_otp`,
  POST_TRANSACTION_HISTORY_NSDL: `${PROXY_BASEURL}/wallet/m2p/fetch_transactions`,
  POST_WALLET_M2P_SET_PIN: `${PROXY_BASEURL}/wallet/m2p/set_pin`,
  POST_WALLET_M2P_LOCK_UNLOCK: `${PROXY_BASEURL}/wallet/m2p/lock_unlock_block`,
  POST_NSDL_BENEFICIARIES: `${PROXY_BASEURL}/wallet/m2p/fetch_beneficiaries`,
  POST_NSDL_ADD_BENEFICIARY: `${PROXY_BASEURL}/wallet/m2p/add_beneficiary`,
  POST_NSDL_UPDATE_BENEFICIARIES: `${PROXY_BASEURL}/wallet/m2p/update_beneficiary`,
  POST_NSDL_FETCH_BENEFICIARY: `${PROXY_BASEURL}/wallet/m2p/fetch_beneficiary`,
  POST_IMPS_M2P_TRANSFER: `${PROXY_BASEURL}/wallet/m2p/imps_transfer`,
  POST_M2P_DELETE_BENEFICIARY: `${PROXY_BASEURL}/wallet/m2p/delete_beneficiary`,
  POST_NSDL_M2P_REQUEST_STATEMENT: `${PROXY_BASEURL}/wallet/m2p/request_statement`,
  GET_NSDL_M2P_FETCH_LIMITS: `${PROXY_BASEURL}/wallet/m2p/fetch_limits`,
  POST_NSDL_M2P_UPDATE_LIMITS: `${PROXY_BASEURL}/wallet/m2p/update_limits`,
  POST_NSDL_M2P_REPLACE_CARD: `${PROXY_BASEURL}/wallet/m2p/replace_request`,
  GET_INITITATE_M2P_KYC: `${PROXY_BASEURL}/wallet/m2p/initiate_kyc_process`,
});

const API_NSDL_ISG_CARD = (PROXY_BASEURL) => ({
  POST_NSDL_ISG_REQUEST_STATEMENT: `${PROXY_BASEURL}/wallet/isg/request_statement`,
  POST_TRANSACTION_HISTORY_NSDL_ISG: `${PROXY_BASEURL}/wallet/isg/transaction_history_inquiry`,
});

const API_INDUSIND_MIN_KYC = (PROXY_BASEURL) => ({
  POST_INDUSIND_MIN_KYC: `${PROXY_BASEURL}/indusind_min_kyc/update_min_kyc`,
  GET_INDUSIND_MIN_KYC_USER_INFO: `${PROXY_BASEURL}/indusind_min_kyc/user_info`,
  GET_INDUSIND_MIN_KYC_CITIES: `${PROXY_BASEURL}/indusind_min_kyc/cities`,
});

const COMMON_ENDPOINTS = ({ PROXY_BASEURL, PROXY_BASEURL_V3, MOBILE_API_BASEURL, MOBILE_IMAGES_BASEURL, PAYMENT_URL, CLIENT_SERIES, CAPTCHA_KEY }) => ({
  // GET_HOME_PAGE: `${GROUP_DINING_BASEURL}/webservices/home_page`,
  POST_PRODUCT_CONTACT_US:
    'https://cors-anywhere.herokuapp.com/https://docs.google.com/forms/u/0/d/e/1FAIpQLSepCVLoP-hsxbMQsKlWC6usoioztl412oZUj-dQBvWvc1bchQ/formResponse',
  GET_HOME_PAGE: `${PROXY_BASEURL}/home_page`,
  GET_GDD_PAGE: `${GROUP_DINING_BASEURL}/webservices/gdd_page`,
  GET_PAY_BALANCE: `${PROXY_BASEURL}/profile/user_balances`,
  GET_MY_ORDERS: `${PROXY_BASEURL}/orders`,
  GET_MY_ORDERS_RETURN: `${PROXY_BASEURL}/orders/return_order_placed`,
  POST_USER_PASSWORD: `${PROXY_BASEURL}/profile/password`,
  GET_USER_INFO_LITE: `${PROXY_BASEURL}/profile/info`,
  PUT_USER_PROFILE: `${PROXY_BASEURL}/profile`,
  GET_CART_LIST: `${PROXY_BASEURL}/orders`, /** @todo duplicate URL exposed same as GET_MY_ORDERS */
  // ADD_CARD_ZSC: `${PROXY_BASEURL}/zaggle_cards`,
  PUT_ACTIVATE_CARD_ZSC: `${PROXY_BASEURL}/zaggle_cards/activate`,
  GET_USER_ADDRESS: `${PROXY_BASEURL}/orders/addresses`,
  CONTACT_US: `${PROXY_BASEURL}/contact_requests`,
  GOOGLE_MAP,
  GOOGLE_DOC:
    'https://docs.google.com/forms/u/3/d/e/1FAIpQLSeJc6-ncjrCS-2VuRoAG5AdEnBYeBskd0-I7oHVRlo-X49Yaw/formResponse',
  PROXY_BASEURL,
  GET_RESTURANT_TAGS: `${GROUP_DINING_BASEURL}/webservices/zag_tags`,
  POST_NOTIFICATION: `${PROXY_BASEURL}/notifications`,
  POST_SEND_OTP: `${PROXY_BASEURL}/auth/otp`,
  RESET_PASSWORD: `${PROXY_BASEURL}/profile/password/token_reset`,
  POST_DEMO_REGISTER: `${PROXY_BASEURL}/demo_registrations/register`,
  GET_EVOUCHER_OTP: `${PROXY_BASEURL}/orders/evouchers/generate_evoucher_otp`,
  POST_APPLY_COUPON_CODE: `${PROXY_BASEURL}/orders/:orderId/apply_propel_coupon_code`,
  GET_CASHFREE_POPUP: `${PROXY_BASEURL}/orders/:order_id/cashfree_pop_up`,
  GET_ORDERS_OTP: `${PROXY_BASEURL}/orders/generate_order_otp`,
  GET_CONFIRM_ORDER_OTP: `${PROXY_BASEURL}/orders/validate_order_confirmation_otp`,
  ...BROWSER_API(PROXY_BASEURL),
  ...API_NODE_SERVER,
  ...API_GIFT_CARD(PROXY_BASEURL),
  ...API_RESTAURANTS(MOBILE_API_BASEURL),
  ...API_IMAGES(MOBILE_IMAGES_BASEURL),
  ...API_NARADA(PROXY_BASEURL),
  ...API_YES_BANK(PROXY_BASEURL),
  ...API_NSDL_M2P_CARD(PROXY_BASEURL),
  ...API_NSDL_ISG_CARD(PROXY_BASEURL),
  ...API_INDUSIND_MIN_KYC(PROXY_BASEURL),
  ...API_YES_BANK_V3(PROXY_BASEURL_V3),
  ...CLIENT_SERIES,
  ...AWS_STATIC_FILES,
  ...PAYMENT_URL,
  ...PressLinks,
  CAPTCHA_KEY,
});

export default COMMON_ENDPOINTS;



// WEBPACK FOOTER //
// client/config/endPoints/commons.js